import styled from 'styled-components'
import { Flex } from 'components/common/styles'

export const RadioContainer = styled(Flex)`
  margin: 10px 0 10px 10px;
  line-height: 20px;

  .MuiRadio-root,
  .MuiCheckbox-root {
    margin-right: 8px;
    padding: 0;
  }
`

export const DatePickerContainer = styled.div`
  max-width: 110px;
  margin-right: 8px;
`

export const TextFieldContainer = styled.div`
  max-width: 45px;
  margin-right: 8px;
`
